let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cp7kj")).then(() => parcelRequire('am9OH'));